var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.75C4.30964 11.75 3.75 12.3096 3.75 13V20C3.75 20.6904 4.30964 21.25 5 21.25H19C19.6904 21.25 20.25 20.6904 20.25 20V13C20.25 12.3096 19.6904 11.75 19 11.75H5ZM2.25 13C2.25 11.4812 3.48122 10.25 5 10.25H19C20.5188 10.25 21.75 11.4812 21.75 13V20C21.75 21.5188 20.5188 22.75 19 22.75H5C3.48122 22.75 2.25 21.5188 2.25 20V13Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C10.8728 2.75 9.79183 3.19777 8.9948 3.9948C8.19777 4.79183 7.75 5.87283 7.75 7V11C7.75 11.4142 7.41421 11.75 7 11.75C6.58579 11.75 6.25 11.4142 6.25 11V7C6.25 5.47501 6.8558 4.01247 7.93414 2.93414C9.01247 1.8558 10.475 1.25 12 1.25C13.525 1.25 14.9875 1.8558 16.0659 2.93414C17.1442 4.01247 17.75 5.47501 17.75 7V11C17.75 11.4142 17.4142 11.75 17 11.75C16.5858 11.75 16.25 11.4142 16.25 11V7C16.25 5.87283 15.8022 4.79183 15.0052 3.9948C14.2082 3.19777 13.1272 2.75 12 2.75Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19C11.4477 19 11 18.5523 11 18V15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V18C13 18.5523 12.5523 19 12 19Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutline);
export default __webpack_public_path__ + "static/media/lock-outline.cb750899962440f40daf347c4758798e.svg";
export { ForwardRef as ReactComponent };